import styled from "styled-components"
import CustomLink from "../../custom-link/custom-link.component"

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.primary.main};
  position: fixed;
  z-index: 1;
  height: 100vh;
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 190px);
  max-width: 215px;
  margin: auto;

  button {
    display: block;
    margin: auto;
  }
`

export const Item = styled(CustomLink)`
  font-size: 1rem;
  text-align: center;
  padding: 0.5em 0;
  display: block;
  transition: all 0.3s ease;
  color: white;

  &.activeRoute {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }
`

export const Description = styled.div`
  text-align: center;
  color: #ffffff;
  margin-top: 2em;

  h2 {
    margin-bottom: 0;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  }

  .phone {
    display: block;
    margin-top: 0;
    margin-bottom: 0.25em;
    color: #ffffff;
    text-decoration: none;
    font-weight: 400;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  }

  .address {
    margin-bottom: 0.25em;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    opacity: 0.75;

    span {
      font-weight: 500;
    }
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #ffffff;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    opacity: 0.75;

    p {
      margin-right: 0.5em;
    }
  }
`
